<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/jiangshunIndex">首页</el-menu-item>
        <el-menu-item index="/jiangshun/gasClamp">全桥实时数据</el-menu-item>
        <el-menu-item index="/jiangshun/currentDataTable?bridgeId=8c363c2c-8e86-499d-80a5-b3718fd4b102">实时数据表</el-menu-item>
        <el-menu-item index="/jiangshun/bridgeImg">全桥除湿总体布置图</el-menu-item>
        <el-submenu :index="'/jiangshun/dataHistory?bridgeId=8c363c2c-8e86-499d-80a5-b3718fd4b102&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/jiangshun/dataHistory?bridgeId=8c363c2c-8e86-499d-80a5-b3718fd4b102&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/jiangshun/dataHistory?bridgeId=8c363c2c-8e86-499d-80a5-b3718fd4b102"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="JIANGMEN" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main jiang-shun">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "liede",
  data() {
    return {
      bridgeId: "8c363c2c-8e86-499d-80a5-b3718fd4b102",
      envInfo: {
        envId: "dc309ef2-4544-4ddd-b4c3-a587fc6d8e6b",
        weather: "01b233c9-20ef-4b5c-9059-cda04d89de2a",
        humidity: "fa6cd706-ab6d-44c5-a4a2-32c5737aa76f",
        temperature: "d811ab31-e5a4-42f6-bf1b-c282b323df37",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;
  display: none;
}
</style>